<template>
  <div class="audio-player">
    <template v-if="src">
      <audio ref="audio" :src="src" preload="metadata" @play="report('audio_play')" @pause="report('audio_pause')" @ended="report('audio_end')" @error="report('audio_error')" />
      <button type="button" :disabled="disabled" @click="play">▶ Play {{ label }}</button>
      <button type="button" class="secondary" @click="$refs.audio.pause()">Pause</button>
      <button type="button" class="secondary" :disabled="disabled" @click="replay">Replay</button>
    </template>
    <template v-else><button type="button" disabled>▶ {{ label }} · Audio not added</button><template v-if="transportControls"><button type="button" class="secondary" disabled>Pause</button><button type="button" class="secondary" disabled>Replay</button></template><span class="muted">No sound will play in this preview.</span></template>
  </div>
</template>
<script>
export default {
  props: { src: { type: String, default: null }, label: { type: String, default: 'Listen' }, materialId: String, stageId: String, disabled: Boolean, transportControls: Boolean },
  emits: ['action'],
  beforeUnmount() { if (this.$refs.audio) this.$refs.audio.pause(); },
  methods: {
    report(type) { this.$emit('action', { type, stage_id: this.stageId || '', material_id: this.materialId, playback_seconds: this.$refs.audio?.currentTime || 0 }); },
    async play() { try { await this.$refs.audio.play(); } catch (error) { this.report('audio_error'); } },
    replay() { this.$refs.audio.currentTime = 0; this.report('audio_replay'); this.play(); }
  }
};
</script>
